import { IRetailerRestrictionData } from "@faire/web-api/indigofair/data/IRetailerRestrictionData";

import { useBrandPageStateContext } from "../contexts/BrandPageStateContext";

export const useRetailerRestriction = ():
  | IRetailerRestrictionData
  | undefined => {
  return useBrandPageStateContext().retailerRestrictions
    ?.retailer_restrictions?.[0];
};
